import Vue from 'vue'

export default {
  resolveGetParams: function (data) {
    return {
      year:       (data && data.year)       ? data.year       : null,
      number:     (data && data.number)     ? data.number     : null,
      order_by:   (data && data.order_by)   ? data.order_by   : 'id',
      order_type: (data && data.order_type) ? data.order_type : 'asc',
      symbol:     (data && data.symbol)     ? data.symbol     : '=',
      page:       (data && data.page)       ? data.page       : 1,
      cursor:     (data && data.cursor)     ? data.cursor     : 0,
      count:      (data && data.count)      ? data.count      : 50,
      filter:     (data && data.filter)     ? data.filter     : {model: [], relation: []},
      custom_filter: (data && data.custom_filter) ? data.custom_filter : null,
      nocache:       (data && data.nocache)       ? data.nocache       : false,
      cache:         (data && data.cache)         ? data.cache         : false,
    }
  },
  getFilter: function (options) {
    if (typeof options === 'undefined') return '';

    let currentPage = (options.currentPage) ? options.currentPage : 1,
      perPage       = (options.perPage)     ? options.perPage     : 100,
      orderBy       = (options.sortBy)      ? options.sortBy      : 'created_at',
      orderType     = (options.sortOrder)   ? options.sortOrder   : 'desc',
      symbol        = (options.symbol)      ? options.symbol      : '=',
      filterArray   = [],
      filter        = '',
      relationFilterArray = [];



    if (typeof options.filter !== 'undefined' && options.filter !== false) {
      for (let key in options.filter) {
        if (options.filter.hasOwnProperty(key)) {
          if ((key.indexOf('.') + 1)) {
            let relation = key.split('.')[0],
                field    = key.split('.')[1],
                value    = options.filter[key];
            if (value !== 'all') relationFilterArray.push('["' + relation + '", "' + field + '", "' + symbol +'", "' + value + '"]')
          } else {
            let value = options.filter[key];
            filterArray.push('["' + key + '", "' + symbol + '", "' + value + '"]')
          }
        }
      }
    }

    if (filterArray.length || relationFilterArray.length) {
      filter = '&filter=%7B';
      if (filterArray.length) filter += '"model": [' + filterArray.join(', "or", ') + ']';
      if (relationFilterArray.length) filter += (filterArray.length ? ', ' : '') + '"relation": [' + relationFilterArray.join(', "or", ') + ']';
      filter += '%7D'
    }

    if (options.filter === false && typeof options.filterString !== undefined) {
      filter = options.filterString;
    }

    return '?order_by=' + orderBy
      + '&order_type='  + orderType
      + '&page='  + currentPage
      + '&count=' + perPage
      + filter;

  }
}



// WEBPACK FOOTER //
// ./src/helpers/db/index.js